import { Grid } from 'antd'
const { useBreakpoint: useAntdBreakpoint } = Grid
export { useAntdBreakpoint as useBreakpoint }
